var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{model:{value:(_vm.expr.name),callback:function ($$v) {_vm.$set(_vm.expr, "name", $$v)},expression:"expr.name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }